import { render, staticRenderFns } from "./viewer_sidebar_panels.vue?vue&type=template&id=7afb28e0&scoped=true&"
import script from "./viewer_sidebar_panels.vue?vue&type=script&lang=js&"
export * from "./viewer_sidebar_panels.vue?vue&type=script&lang=js&"
import style0 from "./viewer_sidebar_panels.vue?vue&type=style&index=0&id=7afb28e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb28e0",
  null
  
)

export default component.exports